import { useFormikContext } from 'formik';
import { ReactElement } from 'react';
import { object, reach } from 'yup';
import { NeglectedOrDelinquentInformationFormValues } from '../../../types/NeglectedOrDelinquentInformationModel';
import { PanelType } from '../../../types/PanelType';
import { createNeglectedOrDelinquentInformationValidationSchema } from '../../../types/Validation/NeglectedOrDelinquentInformationValidationSchema';
import FormTextbox from '../../FormInputs/FormTextbox/FormTextbox';
import Panel from '../../Panel/Panel';

const NeglectedOrDelinquentSchoolReEnrollmentPanel = ({
    disabled,
    validationSchema,
}: {
    disabled: boolean;
    validationSchema: ReturnType<
        typeof createNeglectedOrDelinquentInformationValidationSchema
    >;
}): ReactElement => {
    const { errors } =
        useFormikContext<NeglectedOrDelinquentInformationFormValues>();
    const field = 'schoolReEnrollment.studentsReturnedWithin90DaysOfExiting';
    const inputSchema = object().shape({
        [field]: reach(validationSchema, field),
    });

    return (
        <Panel panelType={PanelType.INFO} heading="School Re-Enrollment">
            <section className="nord-school-re-enrollment">
                <p>
                    <label htmlFor={field}>
                        Provide the <strong>number of students</strong> who returned
                        to the LEA within 90 days of exiting the program:
                    </label>
                </p>
                <FormTextbox
                    field={field}
                    displayName=""
                    disabled={disabled}
                    validationSchema={inputSchema}
                />
                {typeof errors.schoolReEnrollmentLimit === 'string' && (
                    <p className="nord-demographics-error" role="alert">
                        {errors.schoolReEnrollmentLimit}
                    </p>
                )}
            </section>
        </Panel>
    );
};

export default NeglectedOrDelinquentSchoolReEnrollmentPanel;
